<div class="row">
  <div class="col-md-8 mx-auto text-center">
    <h1>CRIAR NOVA CONTA</h1>
  </div>
</div>

<div class="row" *ngIf="isVerify">
  <div class="col-md-8 mx-auto">
    <div class="loader-bubble loader-bubble-primary d-block"></div>
  </div>
</div>

<div class="row" *ngIf="tokenInvalid">
  <div class="col-md-10 mx-auto">
    <ngb-alert [dismissible]="false" class="alert-card col-md-12" [type]="'warning'">
      <span>Seu token expirou, em poucos minutos você receberá em seu e-mail um link para registrar uma nova
        senha.</span>
    </ngb-alert>
  </div>
</div>

<div class="card o-hidden mt-5 mb-5" *ngIf="verifySuccess"
  [@animate]="{value:'*',params:{y:'120px',opacity:'0',delay:'100ms', duration: '400ms'}}">
  <div class="row">
    <div class="col-md-8 mx-auto">
      <div class="p-4">
        <form [formGroup]="form" (validSubmit)="onSubmit($event)">
          <div class="row">
            <div class="col-md-12">
              <mat-form-field>
                <input matInput placeholder="E-MAIL" formControlName="email" type="email">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <mat-form-field>
                <input matInput placeholder="NOME COMPLETO" formControlName="name">
              </mat-form-field>
            </div>
          </div>
          <ng-container *ngIf="dealerMissingAddress">
            <div class="row">
              <div class="col-md-12">
                <mat-form-field>
                  <input matInput placeholder="TELEFONE" formControlName="phoneNumber" type="tel">
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <mat-form-field>
                  <input matInput placeholder="CEP" formControlName="zipCode" (blur)="updateZipCode()" type="tel">
                </mat-form-field>
                <mat-error *ngIf="invalidZipCode">CEP inválido</mat-error>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <mat-form-field>
                  <input matInput placeholder="Endereço" formControlName="address">
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <mat-form-field>
                  <input matInput placeholder="Número" formControlName="addressNumber">
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field>
                  <input matInput placeholder="Complemento" formControlName="addressComplement">
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <mat-form-field>
                  <input matInput placeholder="Bairro" formControlName="district">
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <mat-form-field>
                  <input matInput placeholder="Cidade" formControlName="cityName">
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field>
                  <input matInput placeholder="Estado" formControlName="uf">
                </mat-form-field>
              </div>
            </div>
          </ng-container>
          <div class="row">
            <div class="col-md-12">
              <mat-form-field>
                <input [type]="showPassword ? 'text' : 'password'" matInput placeholder="SENHA"
                  formControlName="password" [noValidate]="passwordValidators.length > 0">
                <mat-icon matSuffix style="cursor: pointer" (click)="showPassword = !showPassword">visibility</mat-icon>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <mat-form-field>
                <input [type]="showConfirmPassword ? 'text' : 'password'" matInput placeholder="CONFIRMAR SENHA"
                  formControlName="passwordConfirm">
                <mat-icon matSuffix style="cursor: pointer" (click)="showConfirmPassword = !showConfirmPassword">
                  visibility</mat-icon>
              </mat-form-field>


              <ngb-alert class="alert col-md-12" [type]="'warning'" [dismissible]="false"
                *ngIf="passwordValidators.length > 0">
                <p>Sua senha precisa ter no mínimo:</p>
                <ul style="list-style: none; padding: 0px">
                  <li *ngFor="let item of passwordValidators">
                    <i class="material-icons">
                      <span *ngIf="!password.value; else validateRule">highlight_off</span>
                      <ng-template #validateRule>
                        <span *ngIf="password.hasError(item.rule); else perfect">highlight_off</span>

                        <ng-template #perfect>
                          <span>check_circle_outline</span>
                        </ng-template>
                      </ng-template>
                    </i><span class="password-error-msg"
                      [ngClass]="{'through': password.value && !password.hasError(item.rule)}">{{item.message}}</span>
                  </li>
                </ul>
              </ngb-alert>


            </div>
          </div>

          <div class="row mt-3">
            <div class="col-md-12">
              <div class="d-flex">
                <mat-checkbox
                  class="d-block"
                  value="acceptTerm"
                  formControlName="acceptTerm"></mat-checkbox>
                <span
                  class="ml-2"
                  [ngClass]="{
                    'text-danger': form.get('acceptTerm').dirty && form.get('acceptTerm').hasError('required')
                    }">
                    Eu li e aceito os
                    <a
                      [href]="termsOfUse"
                      target="_blank">
                      termos de uso
                    </a>
                    desta plataforma.
                  </span>
              </div>
            </div>
          </div>

          <btn-loading btnClass="btn-primary btn-rounded btn-block mt-4 mb-5" [loadingText]="loadingText"
            [loading]="loading$ | async">
            CRIAR CONTA
          </btn-loading>
        </form>
      </div>
    </div>
  </div>
</div>